const errorTypes = {
  null: '',
  generic: 'GENERIC ERROR',
  geoblock: 'GEOBLOCKED ERROR',
};

export default errorTypes;


// WEBPACK FOOTER //
// ./src/misc/error-types/index.js